import {Roles} from "@/enum/roles";
import {taskNames, taskLinks, taskTypes} from "@/enum/task_type";
import Create from "@/app/tasks/stockPickingSet/StockPickingSetCreate.view";
import Show from "@/app/tasks/stockPicking/StockPickingShow.view";

const type = taskTypes.STOCK_PICKING_SET;
const BASE_URL = taskLinks[type];

const routes = {
    create: {
        path: BASE_URL + '/create',
        component: Create,
        meta: {
            title: 'tasks.stockPickingSet.create',
            requireRole: [Roles.CHIEF],
            getParent: () => '/'
        }
    },
    show: {
        name: 'stockPickingSetShow',
        path: BASE_URL + '/:taskId(\\d+)',
        component: Show,
        props: { isTaskSet: true },
        meta: {
            title: taskNames[type],
            requireRole: [Roles.STOREKEEPER, Roles.CHIEF],
            getParent: () => '/',
            trackTime: true
        }
    }
};

export default Object.values(routes);
